const getTranslationsAsync = {
    jp: { i18n_logout: 'ログアウト' },
    en: {
      i18n_add_project:"Add project",
      i18n_organizations_changedat: 'Last Changed',
      i18n_logout: 'Logout',      
      i18n_avatar_account: 'Account',      
      i18n_menu_dashboard: 'Dashboard',
      i18n_menu_contacts: 'Contacts',
      i18n_menu_files: 'Files',
      i18n_menu_agenda: 'Agenda',
      i18n_menu_finance: 'Disbursements',
      i18n_menu_allorganizations: 'All organizations',
      i18n_menu_allbuildings: 'All organizations',
      i18n_menu_allmeters: 'All meters',      
      i18n_menu_dossier: 'Cases',
      i18n_menu_office: 'Office',
      i18n_menu_offers: 'Offers',
      i18n_my_agenda: 'Mijn agenda',
      i18n_items_current: 'Current items',
      i18n_items_total: 'Total',
      i18n_items_per_page: 'Per page',
      i18n_menu_orders: 'Orders',
      i18n_selected: 'Selected',
      i18n_chatattachments: 'Chat attachments',
      i18n_agendaattachments: 'Agenda attachments',
      i18n_mydocuments: 'My documents',
      i18n_root: 'All Files',
      i18n_boughtofferattachments: 'offer attachments',
      i18n_contacts_email:'Email',
      i18n_contacts_givenname:'Firstname',
      i18n_contacts_familyname:'Lastname',
      i18n_contacts_workphone:'Workphone',
      i18n_contacts_phone:'Private Phone',
      i18n_contacts_postalcode:'Postal Code',
      i18n_contacts_housenumber:'House number',
      i18n_contacts_fullname:'Name',
      i18n_contacts_isprofessional:'Is professional',
      i18n_contacts_nameformat:'Nameformat',
      i18n_add_directory: 'Add directory',
      i18n_add_file: 'Add file',
      i18n_fileEntitys_name: 'Name',
      i18n_fileEntitys_createdat: 'Created',
      i18n_contacts_ispublic: 'Public',
      i18n_contacts_createdat: 'Created',
      i18n_edit: 'Edit',
      i18n_delete: 'Delete',
      i18n_save: 'Save',
      i18n_confirm_message: 'Delete?',
      i18n_yes: 'Yes',
      i18n_no: 'No',
      i18n_fileEntitys_entitytype: 'Type',
      i18n_fileEntitys_size: 'Size',
      i18n_download: 'Download',

      i18n_contacts_loginidsNaam: '',
      i18n_contacts_addressid: '',
      i18n_contacts_contactids: '',
      i18n_contacts_createdby: '',
      i18n_fileEntitys_uuid: '',
      i18n_fileEntitys_directoryid: '',
      i18n_fileEntitys_createdby: '',

      i18n_click_here: 'Upload file',
      i18n_drop_here: 'Drop file here',
      i18n_file_upload_name: 'Filename',

      i18n_menu_backlog: 'Backlog',
      i18n_contacts_profilepicture: 'Profile picture',
      i18n_fileEntitys_extension: 'Extension',

      i18n_filter_equals: 'Equal to',
      i18n_filter_not_equals: 'Not equal to',
      i18n_filter_contains: 'Contains',
      i18n_filter_not_contains: "Doesn't contain",
      i18n_filter_starts_with: 'Starts with',
      i18n_filter_not_starts_with: "Doesn't start with",
      i18n_filter_ends_with: 'Ends with',
      i18n_filter_not_ends_with: "Doesn't end with",
      i18n_filter_greater_than: 'Greater than',
      i18n_filter_not_greater_than: 'Not greater than',
      i18n_filter_greater_than_or_equal: 'Greater than or equal to',
      i18n_filter_not_greater_than_or_equal: 'Not greater than or equal to',
      i18n_filter_lesser_than: 'Smaller than',
      i18n_filter_not_lesser_than: 'Not smaller than',
      i18n_filter_lesser_than_or_equal: 'Smaller than or equal to',
      i18n_filter_not_lesser_than_or_equal: 'Not smaller than or equal to',
      i18n_filter_between: 'Between',
      i18n_filter_not_between: 'Not between',
      i18n_filter_from: 'From',
      i18n_filter_not_from: 'Not from',
      i18n_filter_add: 'Add filter',
    },
    nl: {
      i18n_chart_total:"Totaalverbruik",
      i18n_chart_weekday:"Weekdagen",
      i18n_chart_holiday:"Feestdagen",
      i18n_chart_temperature:"Temperatuur",
      i18n_add_project:"Add project",
      i18n_logout: 'Uitloggen',
      i18n_menu_gridexample: 'DataGrid Example',
      i18n_avatar_account: 'Account',      
      i18n_menu_dashboard: 'Dashboard',
      i18n_menu_contacts: 'Contacten',
      i18n_menu_files: 'Bestanden',
      i18n_menu_agenda: 'Agenda',
      i18n_menu_finance: 'Verschotten',
      i18n_menu_dossier: 'Dossiers',
      i18n_menu_office: 'Kantoor pagina',
      i18n_menu_offers: 'Offertes',
      i18n_menu_planner: 'Planner',
      i18n_planning: 'Planning',
      i18n_add_event: 'Taak toevoegen',
      i18n_event_name: 'Taak naam',
      i18n_event_start: 'Begindatum',
      i18n_event_end: 'Einddatum',
      i18n_my_agenda: 'Mijn agenda',
      i18n_kyc_accepted: "Accepteer foto's",
      i18n_items_current: 'Huidige items',
      i18n_items_totalpages: 'Totaal aantal pagina\'s: ',
      i18n_items_per_page: 'Per pagina',
      i18n_menu_orders: 'Orders',
      i18n_selected: 'geselecteerd',
      i18n_chatattachments: 'Chat bijlages',
      i18n_agendaattachments: 'Agenda bijlages',
      i18n_mydocuments: 'Mijn documenten',
      i18n_root: 'Alle bestanden',
      i18n_boughtofferattachments: 'Offerte bijlages',
      i18n_contacts_email:'Email',
      i18n_contacts_givenname:'Voornaam',
      i18n_contacts_familyname:'Achternaam',
      i18n_contacts_workphone:'Werktelefoon',
      i18n_contacts_phone:'Prive telefoon',
      i18n_contacts_postalcode:'Postcode',
      i18n_contacts_housenumber:'Huisnummer',
      i18n_contacts_fullname:'Naam',
      i18n_contacts_isprofessional:'Is professional',
      i18n_contacts_nameformat:'Naam opmaak',
      i18n_add_directory: 'Map toevoegen',
      i18n_add_file: 'Bestand toevoegen',
      i18n_fileEntitys_name: 'Bestandsnaam',
      i18n_fileEntitys_createdat: 'Aangemaakt',
      i18n_contacts_ispublic: 'Openbaar',
      i18n_contacts_createdat: 'Aangemaakt',
      i18n_edit: 'Aanpassen',
      i18n_delete: 'Verwijderen',
      i18n_save: 'Opslaan',
      i18n_confirm_message: 'Verwijderen?',
      i18n_yes: 'Ja',
      i18n_no: 'Nee',
      i18n_fileEntitys_entitytype: 'Soort',
      i18n_fileEntitys_size: 'Grootte',
      i18n_download: 'Downloaden',

      i18n_contacts_loginidsNaam: '',
      i18n_contacts_addressid: '',
      i18n_contacts_contactids: 'Contact IDs',
      i18n_contacts_createdby: 'Aangemaakt door',
      i18n_fileEntitys_uuid: '',
      i18n_fileEntitys_directoryid: '',
      i18n_fileEntitys_createdby: '',
      i18n_click_here: 'Upload Bestand',
      i18n_drop_here: 'Sleep bestand hier',
      i18n_file_upload_name: 'Bestandsnaam',
      i18n_menu_backlog: 'Backlog',
      i18n_analysis:"Analyse",
      i18n_etotal:"Elektriciteit",
      i18n_gtotal:"Gas",
      i18n_contacts_profilepicture: 'Profielfoto',
      i18n_fileEntitys_extension: 'Extensie',
      i18n_filter_equals: 'Gelijk aan',
      i18n_filter_not_equals: 'Niet gelijk aan',
      i18n_filter_contains: 'Bevat',
      i18n_filter_not_contains: 'Bevat niet',
      i18n_filter_starts_with: 'Begint met',
      i18n_filter_not_starts_with: 'Begint niet met',
      i18n_filter_ends_with: 'Eindigd op',
      i18n_filter_not_ends_with: 'Eindigd niet op',
      i18n_filter_greater_than: 'Groter dan',
      i18n_filter_not_greater_than: 'Niet groter dan',
      i18n_filter_greater_than_or_equal: 'Groter dan of gelijk aan',
      i18n_filter_not_greater_than_or_equal: 'Niet groter dan of gelijk aan',
      i18n_filter_lesser_than: 'Kleiner dan',
      i18n_filter_not_lesser_than: 'Niet kleiner dan',
      i18n_filter_lesser_than_or_equal: 'Kleiner dan of gelijk aan',
      i18n_filter_not_lesser_than_or_equal: 'Niet kleiner dan of gelijk aan',
      i18n_filter_between: 'Tussen',
      i18n_filter_not_between: 'Niet tussen',
      i18n_filter_from: 'Vanaf',
      i18n_filter_not_from: 'Niet vanaf',
      i18n_filter_add: 'Filter toevoegen',
      i18n_add_contact: 'Contact Toevoegen',
      i18n_submit_error: 'Er is iets mis gegaan. Probeer het later opniew of neem contact op.',
      i18n_edit_contact: 'Contact aanpassen',
      i18n_Platform: 'Platform',
      i18n_contacts_i18n_creator: 'Aanmaker',
      i18n_contacts_i18n_profilepictureurl: 'Profielfoto',
      i18n_fileEntitys_publicurl: 'Url',
      i18n_directory_name: 'Folder naam',

      i18n_contacts_id: 'ID',
      i18n_contacts_loginids: 'Login IDs',
      i18n_contacts_address: 'Adres',
      i18n_contacts_uuid: 'UUID',
      i18n_organizations_changedat: 'Laatste wijziging',
      i18n_organizations_createdat: 'Aangemaakt op',
      i18n_organizations_displayname: 'Naam',
      i18n_alerts:"Meldingen",
      i18n_alerts_changedat: 'Laatste wijziging',
      i18n_alerts_createdat: 'Aangemaakt op',
      i18n_fixes_createdat: 'Aangemaakt op',
      i18n_fixes_changedat: 'Gewijzigd op',
      i18n_alerts_ended: 'Einddatum',
      i18n_alerts_started: 'Startdatum',      
      i18n_alerts_displayname: 'Naam',
      i18n_alerts_isactive: 'Actief', 
      i18n_fixes:"Verbeteringen",  
      i18n_fixes_displayname: 'Naam',
      i18n_fixes_fixedon: 'Laatste wijziging',   
      i18n_fixes_description: 'Omschrijving',      
      i18n_contacts_blockedcontactids: 'Geblokkeerde contacten IDs',
      i18n_contacts_changedat: 'Aangepast op',
      i18n_contacts_displayname: 'Naam',
      i18n_fileEntitys_displayname: 'Naam',
      i18n_fileEntitys_isdeleted: 'Verwijderd',
      i18n_fileEntitys_isuploaded: 'Geupload',
      i18n_fileEntitys_issecure: 'Beveiligd',
      i18n_fileEntitys_changedat: 'Aangepast op',

      i18n_select_message: 'Selecteer optie',
      i18n_add: 'Toevoegen',
      i18n_select_contacts: 'Contacten selecteren',
      i18n_select_contacts_search: 'Zoeken',

      i18n_menu_capacity: 'Capaciteit',
      i18n_start_week: 'Beginweek',
      i18n_week_amount: 'Aantal weken',
      i18n_week: 'Week',
      i18n_hours: 'Uren',
      i18n_percentage: 'Percentage',
      i18n_delete_error: 'Verwijderen mislukt',
      i18n_delete_success: 'Verwijderd',
      i18n_add_error: 'Toevoegen mislukt',
      i18n_add_success: 'Toegevoegd',

      i18n_menu_projects: 'Projecten',
      i18n_menu_employees: 'Werknemers',
      i18n_month: 'Maand',
      i18n_hour: 'Uur',
      i18n_day:"Dag",
      i18n_meters_highrate:"Hoogtarief",
      i18n_meters_lowrate:"Laagtarief",
      i18n_organizations:"Organisaties",
      i18n_meters:"Meters",
      i18n_contracts:"Contracten",
      i18n_contracts_displayname:"Contractnaam",
      i18n_contracts_highrate:"Hoogtarief",
      i18n_contracts_lowrate:"Laagtarief",
      i18n_contracts_changedat:"Laatst gewijzigd",
      i18n_contracts_createdat:"Aangemaakt op",
      i18n_contracts_start:"Start",
      i18n_contracts_end:"Eind",
      i18n_menu_contracts:"Contracten (soon)",
      i18n_buildings:"Gebouwen",
      i18n_buildings_displayname: "Naam",
      i18n_buildings_streetnumber: "Nummer",
      i18n_buildings_postalcode: "Postcode",
      i18n_buildings_changedat: "Laatst gewijzigd",
      i18n_buildings_createdat: "Aangemaakt",
      i18n_menu_organizationmanagement: "Organisatiemanegement",
      i18n_menu_allorganisations: "Alle organisaties",
      i18n_menu_organizationmanagement: "Organisatiemanagement",
      i18n_createmeterbyean:"Meter toevoegen",
      i18n_createmeterbyean_ean:"EAN",
      i18n_createmeterbyean_highrate:"Hoogtarief",
      i18n_createmeterbyean_lowrate:"Laagtarief",
      i18n_createmeterbyean_externaldataprovider:"Koppeling",
      i18n_createorganization_name:"Naam",
      i18n_createbuilding_name:"Naam",
      i18n_createbuilding:"Gebouw toevoegen",
      i18n_createorganization:"Organisatie toevoegen",
      i18n_createbuilding_streetnumber:"Huisnummer",
      i18n_createbuilding_postalcode:"Postcode",
      i18n_createmeterbyean_gridoperator:"Grid operator",      
      i18n_menu_allorganisations: "Alle organisaties",
      i18n_menu_allbuildings: "Alle gebouwen",
      i18n_add_filter_meters:"Meterfilter",
      i18n_filters_meters:"Meterfilter",
      i18n_createmeterbyean_metertype:"Meter type",
      i18n_filter_add_buildings:"Filter toepassen",
      i18n_filters_organizations:"Organisatiefilter",
      i18n_filters_add_organizations:"Filter toepassen",
      i18n_add_filter_buildings:"Gebouwenfilter",
      i18n_filters_buildings:"Gebouwenfilter",
      i18n_add_filter_organizations:"Organisatie filter",
      i18n_filter_add_meters: "Filter toepassen",
      i18n_menu_allmeters: "Alle meters",
      i18n_meters_displayname: "Naam",
      i18n_meters_isinactive: "Inactief",
      i18n_meters_gridoperator: "Netbeheerder",
      i18n_meters_istussenmeter: "Tussenmeter",
      i18n_meters_ean: "EAN",
      i18n_meters_createdat: "Aangemaakt",
      i18n_meters_changedat: "Laatst gewijzigd",
      i18n_meters_externaldataprovider: "Externe data provider",
      i18n_meters_metertype: "Type",
      i18n_alerts_alerttype: "Melding",
      i18n_organizations_adres:"Adres",
      i18n_organizations_chamberofcommercenumber:"KvK-Nummer",
      i18n_organizations_contact:"Contactpersoon",
      i18n_organizations_email:"Email",      
      i18n_createorganization_adres:"Adres",
      i18n_createorganization_chamberofcommercenumber:"KvK-Nummer",
      i18n_createorganization_contact:"Contactpersoon",
      i18n_createorganization_email:"Email",
      
      i18n_buildings_buildingyear:"Bouwjaar",
      i18n_buildings_floorsize:"Vloeroppervlak",
      i18n_buildings_isolationgrade:"Isolatiegraad",
      i18n_buildings_energylabel:"Energielabel",
      i18n_buildings_usage:"Functie",
      i18n_buildings_rental:"Huur / Verhuur",
      i18n_buildings_occupancyrate:"Bezettingsgraad",
      i18n_buildings_climatetype:"Klimaatsysteem",


      i18n_createbuilding_buildingyear:"Bouwjaar",
      i18n_createbuilding_floorsize:"Vloeroppervlak",
      i18n_createbuilding_isolationgrade:"Isolatiegraad",
      i18n_createbuilding_energylabel:"Energielabel",
      i18n_createbuilding_usage:"Functie",
      i18n_createbuilding_rental:"Huur / Verhuur",
      i18n_createbuilding_occupancyrate:"Bezettingsgraad",
      i18n_createbuilding_climatetype:"Klimaatsysteem",
      i18n_usagedetails_header:"Verbruiksdetails",
      i18n_usagedetails_max:"Maximaal",
      i18n_usagedetails_min:"Minimaal",
      i18n_usagedetails_averages:"Gemiddelde",
      i18n_usagedetails_dataquality:"Datakwaliteit",
      i18n_usagedetails_max_fifteenminutes:"Maximaal kwartier",
      i18n_usagedetails_max_day:"Maximaal dag",
      i18n_usagedetails_max_year:"Maximaal jaar",
      i18n_usagedetails_max_month:"Maximaal maand",
      i18n_usagedetails_max_hour:"Maximaal uur",
      i18n_usagedetails_min_year:"Minimum jaar",
      i18n_usagedetails_min_month:"Minimum maand",
      i18n_usagedetails_min_day:"Minimum dag",
      i18n_usagedetails_min_hour:"Minimum uur",
      i18n_usagedetails_min_fifteenminutes:"Minimum kwartier",
      i18n_usagedetails_averages_day:"Gemiddelde per dag",
      i18n_usagedetails_averages_month:"Gemiddelde per maand",
      i18n_usagedetails_averages_year:"Gemiddelde per jaar",
      i18n_usagedetails_dataquality_amountofdays:"Aantal dagen",
      i18n_usagedetails_dataquality_datapoints:"Data punten",
      i18n_usagedetails_dataquality_missingdatapoints:"Missende datapunten",


    }
}
export default getTranslationsAsync
